export default [
  {
    name: 'Home',
    view: 'Dashboard',
    path: '/',
    meta: {
      breadcrumb: [{ title: 'dashboard.breadcrumb', name: 'Home' }]
    }
  },

  {
    name: 'Login',
    view: 'Login',
    path: '/login',
    meta: {
      layout: 'modal',
      noAuth: true
    }
  },

  {
    name: 'Forbidden',
    view: 'Forbidden',
    path: '/forbidden',
    meta: {
      noAuth: true
    }
  },

  {
    name: 'ReservationsIndex',
    view: 'reservations/Index',
    path: '/reservations',
    icon: '',
    children: [
      {
        name: 'ReservationsList',
        component: () => import(`@/views/reservations/list/Index.vue`),
        path: ''
      },
      {
        name: 'ReservationsTodo',
        component: () => import(`@/views/reservations/list/Todo.vue`),
        path: 'todo'
      },
      {
        name: 'ReservationsTodoLines',
        component: () => import(`@/views/reservations/list/TodoLines.vue`),
        path: 'todo-lines'
      },
      {
        name: 'ReservationsRQ',
        component: () => import(`@/views/reservations/list/Request.vue`),
        path: 'rq'
      },
      {
        name: 'ReservationsRevenue',
        component: () => import(`@/views/reservations/list/Revenue.vue`),
        path: 'revenue'
      }
    ]
  },
  {
    name: 'NewBooking',
    view: 'reservations/modal/Booking',
    path: '/reservation/new',
    meta: {
      layout: 'modal'
    }
  },
  {
    name: 'ViewBooking',
    view: 'reservations/modal/Booking',
    path: '/reservation/:id',
    meta: {
      layout: 'modal'
    },
    children: [
      {
        name: 'ReservationNotes',
        component: () => import(`@/views/reservations/modal/Notes.vue`),
        path: '',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'ReservationConditions',
        component: () => import(`@/views/reservations/modal/Conditions.vue`),
        path: 'conditions',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'ReservationPayment',
        component: () => import(`@/views/reservations/modal/Payment.vue`),
        path: 'payment',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'ReservationDocuments',
        component: () => import(`@/views/reservations/modal/Documents.vue`),
        path: 'documents',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'ReservationEmails',
        component: () => import(`@/views/reservations/modal/Emails.vue`),
        path: 'emails',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'autoBookingLogs',
        component: () => import(`@/views/reservations/modal/AutoBookingLogs.vue`),
        path: 'autoBookingLogs',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'insuranceLogs',
        component: () => import(`@/views/reservations/modal/InsuranceLogs.vue`),
        path: 'insuranceLogs',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'personsImport',
        component: () => import(`@/components/reservation/PersonsImport.vue`),
        path: 'personsImport',
        meta: {
          layout: 'modal'
        }
      }
    ]
  },
  {
    name: 'ReservationOffers',
    view: 'Invoices',
    path: '/reservations/invoices',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        {
          title: 'nav.reservations.breadcrumb',
          name: 'Reserveringen',
          link: true
        },
        { title: 'nav.reservations.offers', name: 'ReservationOffers' }
      ]
    }
  },
  {
    name: 'ReservationActions',
    view: 'Actions',
    path: '/reservations/actions',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        {
          title: 'nav.reservations.breadcrumb',
          name: 'Reserveringen',
          link: true
        },
        { title: 'nav.reservations.actions', name: 'ReservationActions' }
      ]
    }
  },
  {
    name: 'ReservationCancellations',
    view: 'Cancellations',
    path: '/reservations/cancellations',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        {
          title: 'nav.reservations.breadcrumb',
          name: 'Reserveringen',
          link: true
        },
        {
          title: 'nav.reservations.cancellations',
          name: 'ReservationCancellations'
        }
      ]
    }
  },
  {
    name: 'ReservationCustomers',
    view: 'Customers',
    path: '/reservations/customers',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        {
          title: 'nav.reservations.breadcrumb',
          name: 'Reserveringen',
          link: true
        },
        { title: 'nav.reservations.customers', name: 'ReservationCustomers' }
      ]
    }
  },
  {
    name: 'ReservationBusiness',
    view: 'Business',
    path: '/reservations/business',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        {
          title: 'nav.reservations.breadcrumb',
          name: 'Reserveringen',
          link: true
        },
        { title: 'nav.reservations.business', name: 'ReservationBusiness' }
      ]
    }
  },

  {
    name: 'Services',
    view: 'services/Index',
    path: '/services',
    icon: '',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.services.breadcrumb', name: 'Services' }
      ]
    }
  },
  {
    name: 'ServiceType',
    view: 'services/Types',
    path: '/services/:service_type',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.services.breadcrumb', name: 'Services', link: true },
        { title: 'nav.service-type.breadcrumb', name: 'ServiceType' }
      ]
    }
  },
  {
    name: 'NewServiceInfo',
    view: 'services/info/Add',
    path: '/services/:service_type/add',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.services.breadcrumb', name: 'Services', link: true },
        { title: 'general.add', name: 'Add' }
      ]
    }
  },
  {
    name: 'EditServiceInfo',
    view: 'services/info/Edit',
    path: '/services/:service_type/:id',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.services.breadcrumb', name: 'Services', link: true },
        { title: 'general.edit', name: 'Edit' }
      ]
    },
    children: [
      {
        name: 'ServiceNavInfo',
        component: () => import(`@/views/services/info/Info.vue`),
        path: '',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceNavSeasons',
        component: () => import(`@/views/services/info/Seasons.vue`),
        path: 'seasons',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceNavSpecials',
        component: () => import(`@/views/services/info/Specials.vue`),
        path: 'specials',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceNavCancellations',
        component: () => import(`@/views/services/info/Cancellations.vue`),
        path: 'cancellations',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceNavTax',
        component: () => import(`@/views/services/info/Tax.vue`),
        path: 'tax',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceNavJourneys',
        component: () => import(`@/views/services/info/Journeys.vue`),
        path: 'journeys',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceNavSchedule',
        component: () => import(`@/views/services/info/Schedule.vue`),
        path: 'schedule',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceNavPrompt',
        component: () => import(`@/views/services/info/Prompt.vue`),
        path: 'prompt',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceNavLedger',
        component: () => import(`@/views/services/info/Ledger.vue`),
        path: 'ledger',
        meta: {
          navigationType: 'static'
        }
      }
    ]
  },
  {
    name: 'ListServiceInventory',
    view: 'services/inventory/List',
    path: '/services/:service_type/:id/inventory',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.services.breadcrumb', name: 'Services', link: true },
        { title: 'services.inventory.title', name: 'ListServiceInventory' }
      ],
      navigationType: 'static'
    }
  },
  {
    name: 'AddServiceInventory',
    view: 'services/inventory/Add',
    path: '/services/:service_type/:id/inventory/add',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.services.breadcrumb', name: 'Services', link: true },
        { title: 'services.inventory.title', name: 'Inventory', link: true },
        { title: 'general.add', name: 'Add' }
      ],
      navigationType: 'static',
      layout: 'modal'
    }
  },
  {
    name: 'EditServiceInventory',
    view: 'services/inventory/Edit',
    path: '/services/:service_type/:id/inventory/:inventory_id',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.services.breadcrumb', name: 'Services', link: true },
        { title: 'services.inventory.title', name: 'Inventory', link: true },
        { title: 'general.edit', name: 'Edit' }
      ],
      navigationType: 'static'
    },
    children: [
      {
        name: 'ServiceInventoryLayout',
        component: () => import(`@/views/services/inventory/Layout.vue`),
        path: '',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'ServiceInventoryBookings',
        component: () => import(`@/views/services/inventory/Bookings.vue`),
        path: 'bookings',
        meta: {
          layout: 'modal'
        }
      }
    ]
  },
  {
    name: 'TransferServiceList',
    view: 'services/transfer/List',
    path: '/services/transfer/:id/list',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.services.breadcrumb', name: 'Services', link: true },
        { title: 'nav.services.transfer', name: 'Transfer', link: true },
        { title: 'general.list', name: 'List' }
      ],
      navigationType: 'static'
    }
  },
  {
    name: 'ServiceDocuments',
    view: 'services/documents/Index',
    path: '/services/:service_type/:id/documents',
    meta: {
      breadcrumb: []
    },
    children: [
      {
        name: 'ServiceDocumentsDescription',
        component: () => import(`@/views/services/documents/Description.vue`),
        path: '',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceDocumentsTickets',
        component: () => import(`@/views/services/documents/Tickets.vue`),
        path: 'tickets',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceDocumentsExtra',
        component: () => import(`@/views/services/documents/Extra.vue`),
        path: 'extra',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceDocumentsDayToDay',
        component: () => import(`@/views/services/documents/DayToDay.vue`),
        path: 'day-to-day',
        meta: {
          navigationType: 'static'
        }
      }
    ]
  },
  {
    name: 'ServiceContact',
    view: 'services/contact/Index',
    path: '/services/:service_type/:id/contact',
    meta: {
      breadcrumb: []
    },
    children: [
      {
        name: 'ServiceContactContracts',
        component: () => import(`@/views/services/contact/Contracts.vue`),
        path: '',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceContactNotes',
        component: () => import(`@/views/services/contact/Notes.vue`),
        path: 'notes',
        meta: {
          navigationType: 'static'
        }
      }
    ]
  },
  // This one is really generic. Will override most routes, so we'll have to define exact matching routes above this
  {
    name: 'ListServiceOccupancy',
    view: 'services/occupancy/List',
    path: '/services/:service_type/:id/:occupancy_type',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.services.breadcrumb', name: 'Services', link: true },
        { title: 'general.list', name: 'List' }
      ],
      navigationType: 'static'
    }
  },
  {
    name: 'NewServiceOccupancy',
    view: 'services/occupancy/Add',
    path: '/services/:service_type/:id/:occupancy_type/add',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.services.breadcrumb', name: 'Services', link: true },
        { title: 'general.add', name: 'Add' }
      ],
      navigationType: 'static'
    }
  },

  {
    name: 'EditServiceOccupancy',
    view: 'services/occupancy/Edit',
    path: '/services/:service_type/:id/:occupancy_type/:type_id',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.services.breadcrumb', name: 'Services', link: true },
        { title: 'general.edit', name: 'Edit' }
      ]
    },
    children: [
      {
        name: 'ServiceOccupancyInfo',
        component: () => import(`@/views/services/occupancy/Info.vue`),
        path: '',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceOccupancyPrice',
        component: () => import(`@/views/services/occupancy/Prices.vue`),
        path: 'prices',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceOccupancyPax',
        component: () => import(`@/views/services/occupancy/Pax.vue`),
        path: 'pax',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceOccupancyAge',
        component: () => import(`@/views/services/occupancy/Ages.vue`),
        path: 'ages',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceOccupancyOffer',
        component: () => import(`@/views/services/occupancy/Offers.vue`),
        path: 'offers',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceOccupancyFullyBooked',
        component: () => import(`@/views/services/occupancy/FullyBooked.vue`),
        path: 'fully-booked',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceOccupancyAvailability',
        component: () => import(`@/views/services/occupancy/Availability.vue`),
        path: 'availability',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceOccupancySurcharges',
        component: () => import(`@/views/services/occupancy/Surcharges.vue`),
        path: 'surcharges',
        meta: {
          navigationType: 'static'
        }
      },
      {
        name: 'ServiceOccupancyExtra',
        component: () => import(`@/views/services/occupancy/Extras.vue`),
        path: 'extras',
        meta: {
          navigationType: 'static'
        }
      }
    ]
  },
  // {
  //   name: 'Continent',
  //   view: 'services/accommodations/Continent',
  //   path: '/services/accommodations/:continent',
  //   props: true,
  //   meta: {
  //     requiresAuth: true,
  //     breadcrumb: [
  //       {title: 'dashboard.breadcrumb', name: 'Home', link: true},
  //       {title: 'nav.services.breadcrumb', name: 'Services', link: true},
  //       {title: 'Accommodaties', name: 'Accommodaties', link: true},
  //       {title: 'Continent', name: 'Continent'}
  //     ]
  //   }
  // },
  // {
  //   name: 'Country',
  //   view: 'services/accommodations/continent/Country',
  //   path: '/services/accommodations/:continent/:country',
  //   props: true,
  //   meta: {
  //     breadcrumb: [
  //       {title: 'dashboard.breadcrumb', name: 'Home', link: true},
  //       {title: 'nav.services.breadcrumb', name: 'Services', link: true},
  //       {title: 'Accommodaties', name: 'Accommodaties', link: true},
  //       {title: 'Continent', name: 'Continent', link: true},
  //       {title: 'Country', name: 'Country'}
  //     ]
  //   }
  // },
  // {
  //   name: 'City',
  //   view: 'services/accommodations/continent/countries/City',
  //   path: '/services/accommodations/:continent/:country/:city',
  //   props: true,
  //   meta: {
  //     breadcrumb: [
  //       {title: 'dashboard.breadcrumb', name: 'Home', link: true},
  //       {title: 'nav.services.breadcrumb', name: 'Services', link: true},
  //       {title: 'Accommodaties', name: 'Accommodaties', link: true},
  //       {title: 'Continent', name: 'Continent', link: true},
  //       {title: 'Country', name: 'Country', link: true},
  //       {title: 'City', name: 'City'}
  //     ]
  //   }
  // },
  {
    name: 'Travels',
    view: 'Travels',
    path: '/travels',
    icon: '',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.travels.title', name: 'Travels' }
      ]
    }
  },
  {
    name: 'TravelTypes',
    view: 'travels/Types',
    path: '/travels/:service_type'
  },
  {
    name: 'NewTravel',
    view: 'travels/modal/Add',
    path: '/travels/:service_type/add',
    meta: {
      layout: 'modal'
    }
  },
  {
    view: 'travels/modal/Edit',
    path: '/travels/:service_type/:id',
    children: [
      {
        name: 'TravelsNavJourney',
        component: () => import(`@/views/travels/modal/Journey.vue`),
        path: '',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'TravelsNavContent',
        component: () => import(`@/views/travels/modal/Content.vue`),
        path: 'content',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'TravelsNavReviews',
        component: () => import(`@/views/travels/modal/Reviews.vue`),
        path: 'reviews',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'TravelsNavDocuments',
        component: () => import(`@/views/travels/modal/Documents.vue`),
        path: 'documents',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'TravelsNavBookings',
        component: () => import(`@/views/travels/modal/Bookings.vue`),
        path: 'bookings',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'TravelsNavLogs',
        component: () => import(`@/views/travels/modal/Logs.vue`),
        path: 'logs',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'TravelsNavNotes',
        component: () => import(`@/views/travels/modal/Notes.vue`),
        path: 'notes',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'TravelsNavAvailability',
        component: () => import(`@/views/travels/modal/Availability.vue`),
        path: 'availability',
        meta: {
          layout: 'modal'
        }
      },
      {
        name: 'TravelsNavPrompt',
        component: () => import(`@/views/travels/modal/Prompt.vue`),
        path: 'prompt',
        meta: {
          layout: 'modal'
        }
      }
    ]
  },

  {
    name: 'Content',
    view: 'Content',
    path: 'content',
    icon: '',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.content', name: 'Content' }
      ]
    }
  },

  {
    name: 'Reports',
    view: 'Reports',
    path: '/reports',
    icon: '',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.reports.title', name: 'Reports' }
      ]
    },
    children: [
      {
        name: 'TripReports',
        component: () => import(`@/views/reports/TripReports.vue`),
        path: '/reports/trip-reports',
        meta: {
          breadcrumb: [
            { title: 'dashboard.breadcrumb', name: 'Home', link: true },
            { title: 'nav.reports.title', name: 'Reports', link: false },
            { title: 'nav.reports.nav.trip-reports', name: 'TripReports' }
          ]
        }
      },
      {
        name: 'SuplierReports',
        component: () => import(`@/views/reports/SupplierReports.vue`),
        path: '/reports/supplier-reports',
        meta: {
          breadcrumb: [
            { title: 'dashboard.breadcrumb', name: 'Home', link: true },
            { title: 'nav.reports.title', name: 'Reports', link: false },
            { title: 'nav.reports.nav.supplier-reports', name: 'SupplierReports' }
          ]
        }
      },
      {
        name: 'TotalRevenueReports',
        component: () => import(`@/views/reports/TotalRevenueReports.vue`),
        path: '/reports/total-revenue',
        meta: {
          breadcrumb: [
            { title: 'dashboard.breadcrumb', name: 'Home', link: true },
            { title: 'nav.reports.title', name: 'Reports', link: false },
            { title: 'nav.reports.nav.total-revenue-reports', name: 'TotalRevenueReports' }
          ]
        }
      },
      {
        name: 'ReservationsServiceLinesReports',
        component: () => import(`@/views/reports/ReservationsServiceLinesReports.vue`),
        path: '/reports/reservations-service-lines',
        meta: {
          breadcrumb: [
            { title: 'dashboard.breadcrumb', name: 'Home', link: true },
            { title: 'nav.reports.title', name: 'Reports', link: false },
            { title: 'nav.reports.nav.reservations-service-lines-reports', name: 'ReservationsServiceLinesReports' }
          ]
        }
      },
      {
        name: 'CustomersReports',
        component: () => import(`@/views/reports/CustomersReports.vue`),
        path: '/reports/reservations-customers',
        meta: {
          breadcrumb: [
            { title: 'dashboard.breadcrumb', name: 'Home', link: true },
            { title: 'nav.reports.title', name: 'Reports', link: false },
            { title: 'nav.reports.nav.reservations-customers', name: 'CustomersReports' }
          ]
        }
      }
    ]
  },

  {
    name: 'Relations',
    view: 'Relations',
    path: 'relations',
    icon: '',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.relations', name: 'Relations' }
      ]
    }
  },

  {
    name: 'Settings',
    view: 'Settings',
    path: 'settings',
    icon: '',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.settings.title', name: 'Settings' }
      ]
    }
  },
  {
    name: 'General',
    view: 'settings/General',
    path: '/settings/general'
  },
  {
    name: 'CountriesOverview',
    view: 'settings/general/Countries',
    path: '/settings/general/countries'
  },
  {
    name: 'CountriesEdit',
    view: 'settings/general/Countries/Edit',
    path: '/settings/general/countries/edit/:id'
  },
  {
    name: 'ContinentsOverview',
    view: 'settings/general/Continents',
    path: '/settings/general/continents'
  },
  {
    name: 'MailTemplatesOverview',
    view: 'settings/general/MailTemplates',
    path: '/settings/general/templates'
  },
  {
    name: 'Webhook',
    view: 'settings/general/Webhooks',
    path: '/settings/general/webhooks'
  },
  {
    name: 'WebhooksAdd',
    view: 'settings/general/Webhooks/Add',
    path: '/settings/webhooks/add',
    meta: {
      layout: 'modal'
    }
  },
  {
    name: 'WebhooksEdit',
    view: 'settings/general/Webhooks/Edit',
    path: '/settings/webhook/edit/:id',
    meta: {
      layout: 'modal'
    }
  },
  {
    name: 'PriceLoad',
    view: 'settings/PriceLoad',
    path: '/settings/general/price-import'
  },
  {
    name: 'PersonsImport',
    view: 'settings/PersonsImport',
    path: '/settings/general/persons-import'
  },
  {
    name: 'MailTemplatesEdit',
    view: 'settings/general/MailTemplates/Edit',
    path: '/settings/general/templates/edit/:id'
  },
  {
    name: 'ConditionsOverview',
    view: 'settings/Conditions',
    path: '/settings/conditions',
    children: [],
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.settings.nav.conditions.title', name: 'Conditions' }
      ]
    }
  },
  {
    name: 'ConditionsAdd',
    view: 'settings/conditions/Add',
    path: '/settings/conditions/add',
    meta: {
      layout: 'modal'
    }
  },
  {
    name: 'ConditionsEdit',
    view: 'settings/conditions/Edit',
    path: '/settings/conditions/:id',
    meta: {
      layout: 'modal'
    }
  },
  {
    name: 'LedgerOverview',
    view: 'settings/Ledger',
    path: '/settings/ledger',
    children: [],
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.settings.nav.ledger.title', name: 'Ledger' }
      ]
    }
  },
  {
    name: 'LedgerAdd',
    view: 'settings/ledger/Add',
    path: '/settings/ledger/add',
    meta: {
      layout: 'modal'
    }
  },
  {
    name: 'LedgerEdit',
    view: 'settings/ledger/Edit',
    path: '/settings/ledger/:id',
    meta: {
      layout: 'modal'
    }
  },
  {
    name: 'UserOverview',
    view: 'settings/User',
    path: '/settings/user',
    children: [],
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.settings.nav.user.title', name: 'User' }
      ]
    }
  },
  {
    name: 'UserAdd',
    view: 'settings/user/Add',
    path: '/settings/user/add',
    meta: {
      layout: 'modal'
    }
  },
  {
    name: 'UserEdit',
    view: 'settings/user/Edit',
    path: '/settings/user/:id',
    meta: {
      layout: 'modal'
    }
  },
  {
    name: 'Premium',
    view: 'Premium',
    path: 'premium',
    icon: '',
    meta: {
      breadcrumb: [
        { title: 'dashboard.breadcrumb', name: 'Home', link: true },
        { title: 'nav.premium', name: 'Premium' }
      ]
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/paths.js